import { AccredibleChipComponentModule } from '@accredible-frontend-v2/components/chip';
import { environment } from '@accredible-frontend-v2/envs';
import { AccredibleIconComponentModule } from '@accredible-frontend-v2/new-components/icon';
import { AccredibleAccountsRedirectionService } from '@accredible-frontend-v2/services/accounts-redirection';
import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';

const MATERIAL_MODULES = [MatButtonModule, MatIconModule];

export interface JobInsightsCtaConfig {
  description: string;
  link: string;
  linkLabel: string;
  comingSoon: boolean;
  requireAuthentication?: boolean;
}

@Component({
  standalone: true,
  selector: 'rp-job-insights-cta',
  templateUrl: './job-insights-cta.component.html',
  styleUrls: [`./job-insights-cta.component.scss`],
  imports: [
    MATERIAL_MODULES,
    TranslocoModule,
    RouterModule,
    AccredibleChipComponentModule,
    AccredibleIconComponentModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JobInsightsCtaComponent {
  private readonly _accountsRedirection = inject(AccredibleAccountsRedirectionService);

  config = input.required<JobInsightsCtaConfig>();

  ctaButtonLink = computed(() => {
    const baseUrl = `${environment.credentialNetUrl}/personalized-career-insights/${this.config()?.link}`;

    if (!this.config()?.requireAuthentication) {
      return baseUrl;
    }

    return this._accountsRedirection.getLoginUrlCustomOrigin(baseUrl);
  });
}
